(function () {
  var STORAGE_KEY = 'izo_welcome_popup_seen';
  var SHOW_DELAY = 1200;        // popup kaç ms s
  var overlay = document.getElementById('dtPopup');
  if (!overlay) return;

  // tekrar açma
  function hasSeen() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function openPopup() {
    overlay.classList.add('izo-active');
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    overlay.classList.remove('izo-active');
    document.body.style.overflow = '';
    markSeen();
  }

  if (!hasSeen()) {
    setTimeout(openPopup, SHOW_DELAY);
  }

  // Kapatma yolları
  document.getElementById('dtPopupClose').addEventListener('click', closePopup);
  document.getElementById('dtPopupCta').addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('izo-active')) closePopup();
  });

  // Kod kopyalama
  window.dtCopyPopupCode = function (code, el) {
    var action = el.querySelector('.izo-popup-code-action');
    var done = function () {
      if (action) {
        var old = action.textContent;
        action.textContent = 'Copié ✓';
        setTimeout(function () { action.textContent = old; }, 1800);
      }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      var t = document.createElement('textarea');
      t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t); done();
    }
  };
})();